var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2014 21.2507C27.2576 27.304 32.5117 29.3184 32.57 29.3441C32.5255 29.4862 31.7304 32.2148 29.8018 35.0332C28.1347 37.4699 26.4043 39.8977 23.6786 39.948C21.0002 39.9974 20.139 38.3598 17.0769 38.3598C14.0158 38.3598 13.0589 39.8977 10.5235 39.9974C7.89249 40.0969 5.88898 37.3624 4.20794 34.9346C0.772938 29.9685 -1.85211 20.9016 1.67267 14.7812C3.4237 11.7418 6.55293 9.81717 9.94944 9.76782C12.5331 9.71854 14.9717 11.506 16.5511 11.506C18.1295 11.506 21.093 9.35642 24.2083 9.67211C25.5125 9.72639 29.1735 10.1989 31.5242 13.6399C31.3348 13.7573 27.156 16.19 27.2014 21.2507V21.2507ZM22.1678 6.3866C23.5647 4.69578 24.5048 2.342 24.2483 0C22.2349 0.0809224 19.8002 1.3417 18.356 3.03159C17.0617 4.52807 15.9282 6.92328 16.234 9.21892C18.4783 9.39256 20.7709 8.0785 22.1678 6.3866",
    fill: "#8F9BB3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.1104bab1.svg";
export { ForwardRef as ReactComponent };